"use client";

import { useEffect } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Platform error:", error);
    console.error("Error name:", error?.name);
    console.error("Error message:", error?.message);
    console.error("Error stack:", error?.stack);
    console.error("Error digest:", error?.digest);
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-950 px-4">
      <div className="text-center max-w-2xl">
        <h2 className="text-2xl font-bold text-white">Something went wrong</h2>
        <p className="mt-2 text-gray-400">
          {error?.message || "An unexpected error occurred. Please try again."}
        </p>
        {error?.stack && (
          <pre className="mt-4 max-h-64 overflow-auto rounded bg-black/50 p-3 text-left text-xs text-gray-300 whitespace-pre-wrap">
            {error.stack}
          </pre>
        )}
        <button
          onClick={reset}
          className="mt-6 rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-medium text-white hover:bg-blue-700"
        >
          Try again
        </button>
      </div>
    </div>
  );
}
